enum ESessionsCounterColor {
    Red = "red",
    Blue = "blue"
}

export { ESessionsCounterColor }
